import * as React from "react";
import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import { VolumesBrowseMobx } from "../../../mst/stores/workload.draft.container.volume";
import { LoaderSmall } from "../../../components/layout/loader/small";
import { NGButton } from "../../../newcomponents/button/Button";
import { NGKindSelect } from "../../../newcomponents/select/ngkindselect";
import NGAlert from "../../../newcomponents/alert";

interface Props {
  browse: VolumesBrowseMobx;
}
const VolumesProviderModalRaw: React.FC<Props> = ({ browse }) => {
  return (
    <Modal
      title={`Select ${browse.provider === "azure" ? "Azure" : browse.provider.toUpperCase()} Cloud Account`}
      width={500}
      open={browse.page === "provider"}
      closable={false}
      footer={
        <div className="modal-actions">
          <NGButton
            variant="secondary"
            onClick={() => {
              browse.setCloudaccountName("");
              browse.setPage("none");
            }}
          >
            Cancel
          </NGButton>
          <NGButton
            variant="primary"
            loading={browse.isCheckingReach}
            disabled={!browse.cloudaccountName || !browse.browserService.canReach || browse.isCheckingReach}
            onClick={() => browse.prepare()}
          >
            Next
          </NGButton>
        </div>
      }
    >
      {browse.isPreparing ? (
        <div className="flex items-center justify-center flex-col" style={{ height: 300 }}>
          <LoaderSmall />
          <div className="mt-2">Please wait. Loading items.</div>
        </div>
      ) : null}
      {!browse.isPreparing ? (
        <>
          {browse.provider === "aws" ? (
            <NGKindSelect
              className="mb-4"
              kind={"cloudaccount"}
              value={browse.cloudaccountName}
              onChange={browse.setCloudaccountName}
              queries={[{ property: "provider", value: "aws" }]}
            />
          ) : null}
          {browse.provider === "azure" ? (
            <NGKindSelect
              className="mb-4"
              kind={"cloudaccount"}
              value={browse.cloudaccountName}
              onChange={browse.setCloudaccountName}
              queries={[{ property: "provider", value: "azure" }]}
            />
          ) : null}
          {browse.provider === "gcp" ? (
            <NGKindSelect
              className="mb-4"
              kind={"cloudaccount"}
              value={browse.cloudaccountName}
              onChange={browse.setCloudaccountName}
              queries={[{ property: "provider", value: "gcp" }]}
            />
          ) : null}
          {browse.prepareError ? (
            <NGAlert type={"error"} message={"This cloud account cannot reach the provider. Select another one."} />
          ) : null}
          {browse.browserService.reachError ? (
            <NGAlert type={"error"} message={browse.browserService.reachError} />
          ) : null}
        </>
      ) : null}
    </Modal>
  );
};

export const VolumesProviderModal = observer(VolumesProviderModalRaw);
